import { render } from "./InputFormattedExpDate.vue?vue&type=template&id=222df650"
import script from "./InputFormattedExpDate.vue?vue&type=script&lang=js"
export * from "./InputFormattedExpDate.vue?vue&type=script&lang=js"

import exportComponent from "/home/cbo/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__